import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.headersExperienciaProfissional,
                          items: _vm.experienciasProfissionais,
                          "item-key": "id",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VSubheader,
                                    { staticClass: "pl-0" },
                                    [
                                      _c(
                                        VRow,
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
                                            },
                                            [
                                              _vm._v(
                                                " EXPERIÊNCIAS PROFISSIONAIS "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          absolute: "",
                                                          color: "primary",
                                                          dark: "",
                                                          right: "",
                                                          text: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDialogCreateExperienciaProfissional()
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(" Adicionar "),
                                                      _c(
                                                        VIcon,
                                                        { staticClass: "ml-2" },
                                                        [_vm._v(" add_circle ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Clique para adicionar uma experiência profissional"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.nomeCargo`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(" " + _vm._s(item.nomeCargo) + " "),
                                  item.fonte
                                    ? _c(
                                        VChip,
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            color: "success",
                                            outlined: "",
                                            "x-small": "",
                                          },
                                        },
                                        [_vm._v(" Importado ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: `item.tempoExperiencia`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDescricaoTempo(
                                          _vm.getCargaHoraria(item)
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.periodo`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getDescricaoPeriodo(item)) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.actions`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                !item.fonte
                                                  ? _c(
                                                      VBtn,
                                                      _vm._g(
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            color: "secondary",
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openDialogUpdateExperienciaProfissional(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("edit"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para editar a experiência profissional"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                !item.fonte
                                                  ? _c(
                                                      VBtn,
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            color: "error",
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmDelete(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v("delete"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para excluir a experiência profissional"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("areas-perfil-select", {
                        attrs: {
                          areas: _vm.perfil.areasProfissional,
                          lista: _vm.listaAreasProfissional,
                          "maximo-areas": 5,
                          icone: "business_center",
                          tipo: "ATUACAO",
                          "mostrar-instrutor": false,
                        },
                        on: {
                          confirm: (value) => _vm.saveAreasAtuacao(value),
                          return: (value) => _vm.saveAreasAtuacao(value),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-experiencia-profissional", {
        attrs: { "dialog-props": _vm.dialogs.dialogExperienciaProfissional },
      }),
      _vm.dialogs.dialogRemoveExperiencia.visibilidade
        ? _c("dialog-remove", {
            attrs: {
              "confirm-action": _vm.deleteExperienciaProfissional,
              "dialog-visible":
                _vm.dialogs.dialogRemoveExperiencia.visibilidade,
              "toogle-visible": _vm.toogleDialogRemoveExperienciaProfissional,
              descricao:
                "Você realmente deseja excluir essa experiência profissional?",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }